import {animate as anime} from 'animejs';

export default class NavBarSearch {
    constructor(el) {
        this.el = el;
        this.isOpen = false;
        this.searchButton = el.querySelector('.masthead__search-button');
        this.searchBar = el.querySelector('.masthead__search-bar');
        this.searchInput = el.querySelector('.masthead__search-input');
        this.mastheadNav = document.getElementById('masthead-nav');
        this.closeSearchButton = document.getElementById('close-search-button');
        this.mastheadBanner = document.getElementById('masthead-banner');
        this.mastheadLanguagePicker = document.querySelector('.language-selector');

        this.searchButton.addEventListener('click', () => { this.openSearch() });
        this.closeSearchButton.addEventListener('click', () => { this.closeSearch() });
    }

    openSearch() {
        this.isOpen = true;
        console.log('open');
        this.mastheadNav.style.overflow = 'hidden';

        console.log(this.mastheadLanguagePicker);

        if(this.mastheadLanguagePicker) {
            this.mastheadLanguagePicker.style.display = 'none';
        }

        if(window.innerWidth < 1200) {
            anime(this.mastheadBanner, {
                opacity:0,
                duration: 300,
                ease: 'inOutExpo'
            });

            anime(this.searchButton, {
                opacity:0,
                duration: 300,
                ease: 'inOutExpo'
            });
        }

        anime(this.mastheadNav, {
            width:0,
            duration: 500,
            ease: 'inOutExpo'
        });

        this.closeSearchButton.style.width = '24px';

        anime(this.closeSearchButton, {
            opacity:1,
            duration: 400,
            delay:400,
            ease: 'inOutExpo'
        });

        let animateFromWidth = getComputedStyle(this.el).width;
        this.el.classList.add('masthead__search--open');
        let animateWidthTo = getComputedStyle(this.el).width;
        this.el.style.width = 0;

        anime(this.el, {
            width:[animateFromWidth, animateWidthTo],
            duration: 800,
            ease: 'inOutExpo'
        });

        anime(this.searchBar, {
            opacity:1,
            duration: 800,
            ease: 'inOutExpo',
            delay: 100
        });
    }

    closeSearch() {
        this.isOpen = false;

        if(window.innerWidth < 1200) {
            anime(this.mastheadBanner, {
                opacity:1,
                duration: 300,
                ease: 'inOutExpo'
            });

            anime(this.searchButton, {
                opacity:1,
                duration: 300,
                ease: 'inOutExpo'
            });
        }

        this.mastheadNav.style.width = 'auto';
        let animateWidthTo = getComputedStyle(this.mastheadNav).width;
        this.mastheadNav.style.width = 0;

        anime(this.searchBar, {
            opacity:0,
            duration: 300,
            ease: 'inOutExpo'
        });

        this.closeSearchButton.style.width = 0;

        anime(this.closeSearchButton, {
            opacity:0,
            duration: 400,
            ease: 'inOutExpo'
        });

        anime(this.closeSearchButton, {
            opacity:0,
            duration: 400,
            ease: 'inOutExpo'
        });

        anime(this.mastheadNav, {
            width:animateWidthTo,
            duration: 500,
            ease: 'inOutExpo',
            complete:() => {
                this.mastheadNav.style.overflow = 'visible';
                if(this.mastheadLanguagePicker) {
                    this.mastheadLanguagePicker.style.display = 'block';
                }
            }
        });

        let animateFromWidth = getComputedStyle(this.el).width;
        this.el.classList.remove('masthead__search--open');
        this.el.style.removeProperty('width');
        let animateToWidth = getComputedStyle(this.el).width;
        this.el.classList.add('masthead__search--open');

        anime(this.el, {
            width:[animateFromWidth, animateToWidth],
            duration: 800,
            ease: 'inOutExpo',
            complete: () => {
                this.el.classList.remove('masthead__search--open');
                this.el.style.removeProperty('width');
            }
        });
    }

    toggleSearchBar() {
        if(this.isOpen) {
            this.closeSearch();
        } else {
            this.openSearch();
        }
    }
};
